module.exports = __webpack_public_path__ + "static/media/cimb.fae89aa7.png";